import { render } from "./GemMechanism05.vue?vue&type=template&id=a74cf336&scoped=true"
import script from "./GemMechanism05.vue?vue&type=script&lang=js"
export * from "./GemMechanism05.vue?vue&type=script&lang=js"

import "./GemMechanism05.vue?vue&type=style&index=0&id=a74cf336&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74cf336"]])

export default __exports__